import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=71d5a061&scoped=true"
import script from "./KanbanView.vue?vue&type=script&lang=js"
export * from "./KanbanView.vue?vue&type=script&lang=js"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=71d5a061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5a061",
  null
  
)

export default component.exports